import {iFrameConnection} from "./services/IFrameConnection.js";
import {IFrameMessages} from "../blink-sdk/messaging/IFrameMessages.js";
import {authService} from "../client/connection/services/AuthService.js";
import {userService} from "../client/connection/services/UserService.js";
import {iFrameState} from "./services/IFrameState.js";
import {iFrameMerchantService} from "./services/IframeMerchantService.js";
import {IFRAME_APP_TYPE, PANEL_TYPE, TEST_MODE} from "../blink-sdk/Constants.js";
import {PanelApp} from "./panel/PanelApp.jsx";
import {WidgetApp} from "./widget/WidgetApp.jsx";
import {iFrameAnalyticsService} from "./services/IFrameAnalyticsService.js";
import {EventSender} from "../blink-sdk/utils/AnalyticsClient.js";
import {iFrameAuthService} from "./services/IFrameAuthService.js";
import {addMetadataAPIPreprocessor} from "./services/APIMetadataPreprocessor.js";
import {GlobalState} from "../stem-core/src/state/State.js";
import {BlinkGlobal} from "./UtilsLib.js";
import {AutomationHelper} from "./AutomationHelper.js";
import {SetDefaultDateFormat} from "../stem-core/src/time/Date.js";
import {DEFAULT_DATE_FORMAT} from "./Constants.js";

const eventsReceivedFromIFrames = new WeakSet();

function initGlobalStateSync() {
    let applyingClearEvent = false;

    iFrameConnection.addIframesListener(IFrameMessages.UPDATE_GLOBAL_STATE, ({event, userId}) => {
        BlinkGlobal.userId = userId;
        eventsReceivedFromIFrames.add(event);
        if (event.type === "clear") {
            applyingClearEvent = true;
            GlobalState.getStore(event.objectType).clear();
            applyingClearEvent = false;
        } else {
            GlobalState.applyEvent(event);
        }
    });

    for (const store of GlobalState.stores.values()) {
        store.addChangeListener((obj, event) => {
            if (event == null) {
                // Prevent infinite recursion.
                if (applyingClearEvent) {
                    return;
                }
                event = {type: "clear", objectType: store.objectType};
            }
            if (!eventsReceivedFromIFrames.has(event)) {
                iFrameConnection.sendToIFrames(IFrameMessages.UPDATE_GLOBAL_STATE, {event, userId: BlinkGlobal.userId});
            }
        });
    }
}

export function initIFrameApp({publicData, iframeParams, merchantId, merchantToken, appType}) {
    iFrameConnection.setAppType(appType);
    authService.setPublicData(publicData);
    iFrameState.init(iframeParams);
    iFrameMerchantService.init(merchantId);
    iFrameAuthService.init(merchantToken);
    iFrameAnalyticsService.init(appType === IFRAME_APP_TYPE.widget ? EventSender.wallet : EventSender.panel);
    addMetadataAPIPreprocessor();

    if (TEST_MODE && !window.Bundle && appType === IFRAME_APP_TYPE.widget) {
        window.Bundle = {AutomationHelper};
    }

    SetDefaultDateFormat(DEFAULT_DATE_FORMAT);

    const initIframeApp = () => {
        const iframeAppClass = appType === IFRAME_APP_TYPE.panel ? PanelApp : WidgetApp;
        initGlobalStateSync();
        iframeAppClass.init();
    }

    const executeInit = () => {
        BlinkGlobal.appType = appType;
        if (authService.isAuthenticated()) {
            userService.ensureUserDataRequested(initIframeApp);
        } else {
            initIframeApp();
        }
    };

    const canExecuteInit = () => iFrameState.panelType !== PANEL_TYPE.payment || iFrameState.iframeParams.paymentDetails;

    if (!canExecuteInit()) {
        const listener = iFrameState.addChangeListener(() => {
            if (canExecuteInit()) {
                listener.remove();
                executeInit();
            }
        })
    } else {
        executeInit();
    }
}
